import { Navigate, createFileRoute } from '@tanstack/react-router'

import { useNetworkingAvailability } from '@/features/networking'
import { ACCOUNT_PATHS, NetworkingPanel } from '@/features/user/profile'

/**
 * A guarda vive no componente, não em `beforeLoad`: a disponibilidade depende de
 * react-query e do store do zustand, que só existem dentro da árvore React.
 *
 * Enquanto a declaração está em voo, renderiza nada em vez de redirecionar —
 * decidir cedo demais expulsaria da rota quem tem acesso legítimo.
 */
function NetworkingRoute() {
  const { isLoading, isAvailable } = useNetworkingAvailability()

  if (isLoading) return null
  if (!isAvailable) return <Navigate to={ACCOUNT_PATHS.profile} replace />

  return <NetworkingPanel />
}

export const Route = createFileRoute('/_event/minha-conta/networking')({
  component: NetworkingRoute
})
